<div
  class="info-box info-box--{{ infoType.toLowerCase() }}"
  [attr.data-cy]="'info-box-' + infoType.toLowerCase()"
>
  <div *ngIf="icon" class="icon">
    <em class="fas fa-{{ icon }}"></em>
  </div>
  <div *ngIf="title" class="title">
    {{ title | cxTranslate }}
  </div>
  <div class="description">
    <ng-container *ngIf="text; else slot">
      {{ text | cxTranslate }}
    </ng-container>
    <ng-template #slot>
      <ng-content></ng-content>
    </ng-template>
  </div>
</div>
